<p>
  community-invites-tab works!
</p>
